module.exports = __webpack_public_path__ + "static/img/01t.3ee1827.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/uvegtablak-falburkolatok/01t.jpg
// module id = 630
// module chunks = 0